export default __webpack_public_path__ + "static/media/close-arrow-24px-rounded.dae7b0eb.svg";